module.exports = __webpack_public_path__ + "img/VC.1911ce59.svg";